import './TagDescriptionSection.scss';
import { coreActions } from '@sonar-software/sonar-core';
import { Space } from 'antd';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY, TAG_DESCRIPTION } from '@sonar-software/sonar-ts-constants';
import { PlaintextEditor, SonarText } from '@ui/text';
import React, { useCallback } from 'react';
import { useAction, useTagReference } from '@hooks';
export const TagDescriptionSection = ({ tagId }) => {
    const tag = useTagReference(tagId);
    const requestPut = useAction(coreActions.requestPutCoreTagsById);
    const handleSave = useCallback((value) => {
        if (tagId && tag.description !== value) {
            requestPut(Object.assign(Object.assign({}, tag), { description: value }));
        }
    }, [requestPut, tag, tagId]);
    return (React.createElement(Space, { className: 'tag-description-section', direction: 'vertical', size: 4 },
        React.createElement(SonarText, { size: 16, weight: 'semibold' }, COPY_SPECIFIC.DESCRIPTION),
        React.createElement(PlaintextEditor, { canBeEmpty: true, isPeriscope: true, isReadOnly: tag.autoTagged, maxLength: TAG_DESCRIPTION.MAX_LENGTH, maxRows: 1, onSave: handleSave, placeholder: PLACEHOLDERS_COPY.ADD_A_DESCRIPTION, saveOnEnter: true, value: tag.description })));
};
